import Box from '@material-ui/core/Box'
import Divider from '@material-ui/core/Divider'

const MenuDivider = () => <Box my={2}><Divider /></Box>

export default MenuDivider
